
import { MlaBorrowerInfoResponse, MlaDashboardResponse, OriginationApplicationModel } from '@ld.consumer-portal/models';
import { EndpointScenarioMap } from './mock.types';

export const mlaBorrowerInfoMock: EndpointScenarioMap<MlaBorrowerInfoResponse> = {
  default: {
    success: true,
    data: [
      {
        borrowerInfoId: 'borrower-001',
        firstName: 'John',
        lastName: 'Doe',
        email: 'john.doe@example.com',
        phone: '555-123-4567',
        ssnVerify: true,
        isPrimary: true,
        borrowerToken: 'mock-borrower-token-base64-encoded',
        mostRecentPhoneNumber: '(909)301-4114',
        phoneNumbers: ['(909)301-4114', '(951)507-5661'],
      },
    ],
  },
  'with-coborrower': {
    success: true,
    data: [
      {
        borrowerInfoId: 'borrower-001',
        firstName: 'John',
        lastName: 'Doe',
        email: 'john.doe@example.com',
        phone: '555-123-4567',
        ssnVerify: true,
        isPrimary: true,
        borrowerToken: 'mock-borrower-token-primary',
        mostRecentPhoneNumber: '(909)301-4114',
        phoneNumbers: ['(909)301-4114', '(951)507-5661'],
      },
      {
        borrowerInfoId: 'borrower-002',
        firstName: 'Jane',
        lastName: 'Doe',
        email: 'jane.doe@example.com',
        phone: '555-987-6543',
        ssnVerify: true,
        isPrimary: false,
        borrowerToken: 'mock-borrower-token-coborrower',
        mostRecentPhoneNumber: '(714)555-1234',
        phoneNumbers: ['(714)555-1234'],
      },
    ],
  },
  'no-borrowers': {
    success: true,
    data: [],
  },
};

export const mlaDashboardMock: EndpointScenarioMap<MlaDashboardResponse> = {
  'with-application': {
    success: true,
    data: {
      loans: [
        {
          loanID: 'mla-001',
          displayLoanId: 'L0012345678',
          status: 'Application Pending',
          loanDashboardCategory: 'PendingApproval',
          loanType: 'Purchase',
          mortgageProviderType: 'MortgageRetail',
          subjectAddress: {
            street: '456 Oak Avenue',
            city: 'Costa Mesa',
            state: 'CA',
            zipCode: '92627',
          },
          borrowers: [
            {
              borrowerID: 'borrower-001',
              firstName: 'John',
              lastName: 'Doe',
              email: 'john.doe@example.com',
              openTasks: 5,
              position: 'Primary',
              isLoggedInBorrower: true,
            },
          ],
          amount: 550000,
          term: '30 Year Fixed',
          purpose: 'Purchase',
          redirectURL: 'https://mla.loandepot.com/loan/mla-001/tasks',
          lastModifiedDate: new Date().toISOString(),
          createdDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        },
      ],
    },
  },
  'unsubmitted-purchase': {
    success: true,
    data: {
      loans: [
        {
          loanID: 'mla-unsubmitted-001',
          displayLoanId: 'L0019978392',
          status: 'Continue Application',
          loanDashboardCategory: 'Unsubmitted',
          loanType: 'Purchase',
          mortgageProviderType: 'MortgageRetail',
          subjectAddress: {
            street: '789 Elm Street',
            city: 'Huntington Beach',
            state: 'CA',
            zipCode: '92648',
          },
          borrowers: [
            {
              borrowerID: 'borrower-002',
              firstName: 'John',
              lastName: 'Doe',
              email: 'john.doe@example.com',
              openTasks: 0,
              position: 'Primary',
              isLoggedInBorrower: true,
            },
          ],
          amount: 475000,
          term: '30 Year Fixed',
          purpose: 'Purchase',
          redirectURL: 'https://mla.loandepot.com/loan/mla-unsubmitted-001/continue',
          lastModifiedDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
          createdDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        },
      ],
    },
  },
  'multiple-applications': {
    success: true,
    data: {
      loans: [
        {
          loanID: 'mla-001',
          displayLoanId: 'L0012345678',
          status: 'Application Pending',
          loanDashboardCategory: 'PendingApproval',
          loanType: 'Purchase',
          mortgageProviderType: 'MortgageRetail',
          subjectAddress: {
            street: '456 Oak Avenue',
            city: 'Costa Mesa',
            state: 'CA',
            zipCode: '92627',
          },
          borrowers: [
            {
              borrowerID: 'borrower-001',
              firstName: 'John',
              lastName: 'Doe',
              email: 'john.doe@example.com',
              openTasks: 5,
              position: 'Primary',
              isLoggedInBorrower: true,
            },
          ],
          amount: 550000,
          term: '30 Year Fixed',
          purpose: 'Purchase',
          redirectURL: 'https://mla.loandepot.com/loan/mla-001/tasks',
          lastModifiedDate: new Date().toISOString(),
          createdDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        },
        {
          loanID: 'refi-001',
          displayLoanId: 'L0098765433',
          status: 'Conditional Approval',
          loanDashboardCategory: 'PendingApproval',
          loanType: 'Refinance',
          mortgageProviderType: 'MortgageRetail',
          subjectAddress: {
            street: '789 Maple Drive',
            city: 'Newport Beach',
            state: 'CA',
            zipCode: '92660',
          },
          borrowers: [
            {
              borrowerID: 'borrower-001',
              firstName: 'John',
              lastName: 'Doe',
              email: 'john.doe@example.com',
              openTasks: 2,
              position: 'Primary',
              isLoggedInBorrower: true,
            },
          ],
          amount: 680000,
          term: '15 Year Fixed',
          purpose: 'Refinance',
          redirectURL: 'https://mla.loandepot.com/loan/refi-001/tasks',
          lastModifiedDate: new Date().toISOString(),
          createdDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
        },
      ],
    },
  },
  'active-and-funded': {
    success: true,
    data: {
      loans: [
        {
          loanID: 'refi-001',
          displayLoanId: 'L0098765432',
          status: 'Application Pending',
          loanDashboardCategory: 'PendingApproval',
          loanType: 'Refinance',
          mortgageProviderType: 'MortgageRetail',
          subjectAddress: {
            street: '123 Main Street',
            city: 'Irvine',
            state: 'CA',
            zipCode: '92618',
          },
          borrowers: [
            {
              borrowerID: 'borrower-001',
              firstName: 'John',
              lastName: 'Doe',
              email: 'john.doe@example.com',
              openTasks: 3,
              position: 'Primary',
              isLoggedInBorrower: true,
            },
          ],
          amount: 425000,
          term: '30 Year Fixed',
          purpose: 'Refinance',
          redirectURL: 'https://mla.loandepot.com/loan/refi-001/tasks',
          lastModifiedDate: new Date().toISOString(),
          createdDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
        },
        {
          loanID: 'purchase-001',
          displayLoanId: 'L0098765499',
          status: 'In Progress',
          loanDashboardCategory: 'PendingApproval',
          loanType: 'Purchase',
          mortgageProviderType: 'MortgageRetail',
          subjectAddress: {
            street: '1234 Luxury Lane',
            city: 'Irvine',
            state: 'CA',
            zipCode: '92620',
          },
          borrowers: [
            {
              borrowerID: 'borrower-001',
              firstName: 'Christopher',
              lastName: 'Brown',
              email: 'christopher.brown@example.com',
              openTasks: 2,
              position: 'Primary',
              isLoggedInBorrower: true,
            },
          ],
          amount: 750000,
          term: '30 Year Fixed',
          purpose: 'Purchase',
          redirectURL: 'https://mla.loandepot.com/loan/purchase-001/tasks',
          lastModifiedDate: new Date().toISOString(),
          createdDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        },
        {
          loanID: 'loan-funded-001',
          displayLoanId: 'L0012345800',
          status: 'Funded',
          loanDashboardCategory: 'Paying',
          loanType: 'Purchase',
          mortgageProviderType: 'MortgageRetail',
          subjectAddress: {
            street: '200 Sunrise Blvd',
            city: 'Laguna Niguel',
            state: 'CA',
            zipCode: '92677',
          },
          borrowers: [
            {
              borrowerID: 'borrower-001',
              firstName: 'John',
              lastName: 'Doe',
              email: 'john.doe@example.com',
              openTasks: 0,
              position: 'Primary',
              isLoggedInBorrower: true,
            },
          ],
          amount: 500000,
          term: '30 Year Fixed',
          purpose: 'Purchase',
          redirectURL: 'https://mla.loandepot.com/loan/loan-funded-001',
          lastModifiedDate: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
          createdDate: new Date(Date.now() - 120 * 24 * 60 * 60 * 1000).toISOString(),
        },
        {
          loanID: 'loan-historic-002',
          displayLoanId: 'L0012340001',
          status: 'Paid Off',
          loanDashboardCategory: 'Historic',
          loanType: 'Purchase',
          mortgageProviderType: 'MortgageRetail',
          subjectAddress: {
            street: '888 Legacy Lane',
            city: 'Mission Viejo',
            state: 'CA',
            zipCode: '92691',
          },
          borrowers: [
            {
              borrowerID: 'borrower-001',
              firstName: 'John',
              lastName: 'Doe',
              email: 'john.doe@example.com',
              openTasks: 0,
              position: 'Primary',
              isLoggedInBorrower: true,
            },
          ],
          amount: 325000,
          term: '30 Year Fixed',
          purpose: 'Purchase',
          redirectURL: 'https://servicing.loandepot.com/loan/L0012340001/history',
          lastModifiedDate: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString(),
          createdDate: new Date(Date.now() - 730 * 24 * 60 * 60 * 1000).toISOString(),
        },
      ],
    },
  },
  'no-application': {
    success: true,
    data: {
      loans: [],
    },
  },
  'with-refinance': {
    success: true,
    data: {
      loans: [
        {
          loanID: 'refi-001',
          displayLoanId: 'L0098765432',
          status: 'Application Pending',
          loanDashboardCategory: 'PendingApproval',
          loanType: 'Refinance',
          mortgageProviderType: 'MortgageRetail',
          subjectAddress: {
            street: '123 Main Street',
            city: 'Irvine',
            state: 'CA',
            zipCode: '92618',
          },
          borrowers: [
            {
              borrowerID: 'borrower-001',
              firstName: 'John',
              lastName: 'Doe',
              email: 'john.doe@example.com',
              openTasks: 3,
              position: 'Primary',
              isLoggedInBorrower: true,
            },
          ],
          amount: 425000,
          term: '30 Year Fixed',
          purpose: 'Refinance',
          redirectURL: 'https://mla.loandepot.com/loan/refi-001/tasks',
          lastModifiedDate: new Date().toISOString(),
          createdDate: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toISOString(),
        },
      ],
    },
  },
};

export const originationApplicationsMock: EndpointScenarioMap<OriginationApplicationModel[]> = {
  'with-application': [
    {
      id: 'mla-001',
      propertyAddress: '456 Oak Avenue, Costa Mesa, CA 92627',
      loanNumber: 'L0012345678',
      loanAmount: 550000,
      interestRate: 6.75,
      estimatedClosingDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
      tasksCount: 5,
      status: 'PendingApproval',
      statusLabel: 'Application Pending',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://mla.loandepot.com/loan/mla-001/tasks',
    },
  ],
  'with-refinance': [
    {
      id: 'refi-001',
      propertyAddress: '123 Main Street, Irvine, CA 92618',
      loanNumber: 'L0098765432',
      loanAmount: 425000,
      interestRate: 5.875,
      estimatedClosingDate: new Date(Date.now() + 21 * 24 * 60 * 60 * 1000),
      tasksCount: 3,
      status: 'PendingApproval',
      statusLabel: 'Application Pending',
      loanProgram: '30 Year Fixed',
      loanType: 'Refinance',
      monthlySavings: 250,
      newMonthlyPayment: 2150,
      redirectURL: 'https://mla.loandepot.com/loan/refi-001/tasks',
    },
  ],
  'unsubmitted-purchase': [
    {
      id: 'mla-unsubmitted-001',
      propertyAddress: '789 Elm Street, Huntington Beach, CA 92648',
      loanNumber: 'L0019978392',
      loanAmount: 475000,
      interestRate: 6.5,
      estimatedClosingDate: undefined,
      tasksCount: 0,
      status: 'Unsubmitted',
      statusLabel: 'Continue Application',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://mla.loandepot.com/loan/mla-unsubmitted-001/continue',
      lastModifiedDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
      createdDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
    },
  ],
  'unsubmitted-refinance': [
    {
      id: 'refi-unsubmitted-001',
      propertyAddress: '123 Main Street, Irvine, CA 92618',
      loanNumber: 'L0098765500',
      loanAmount: 380000,
      interestRate: 5.625,
      estimatedClosingDate: undefined,
      tasksCount: 0,
      status: 'Unsubmitted',
      statusLabel: 'Continue Application',
      loanProgram: '30 Year Fixed',
      loanType: 'Refinance',
      monthlySavings: 200,
      newMonthlyPayment: 2350,
      redirectURL: 'https://mla.loandepot.com/loan/refi-unsubmitted-001/continue',
      lastModifiedDate: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
      createdDate: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
    },
  ],
  'multiple-applications': [
    {
      id: 'mla-001',
      propertyAddress: '456 Oak Avenue, Costa Mesa, CA 92627',
      loanNumber: 'L0012345678',
      loanAmount: 550000,
      interestRate: 6.75,
      estimatedClosingDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
      tasksCount: 5,
      status: 'PendingApproval',
      statusLabel: 'Application Pending',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://mla.loandepot.com/loan/mla-001/tasks',
    },
    {
      id: 'refi-001',
      propertyAddress: '789 Maple Drive, Newport Beach, CA 92660',
      loanNumber: 'L0098765433',
      loanAmount: 680000,
      interestRate: 5.625,
      estimatedClosingDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000),
      tasksCount: 2,
      status: 'PendingApproval',
      statusLabel: 'Conditional Approval',
      loanProgram: '15 Year Fixed',
      loanType: 'Refinance',
      monthlySavings: 425,
      newMonthlyPayment: 4800,
      redirectURL: 'https://mla.loandepot.com/loan/refi-001/tasks',
    },
  ],
  'mixed-status-applications': [
    {
      id: 'mla-unsubmitted-002',
      propertyAddress: '100 Beach Blvd, San Clemente, CA 92672',
      loanNumber: 'L0012345700',
      loanAmount: 625000,
      interestRate: 6.25,
      estimatedClosingDate: undefined,
      tasksCount: 0,
      status: 'Unsubmitted',
      statusLabel: 'Continue Application',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://mla.loandepot.com/loan/mla-unsubmitted-002/continue',
      lastModifiedDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
    },
    {
      id: 'refi-pending-001',
      propertyAddress: '789 Maple Drive, Newport Beach, CA 92660',
      loanNumber: 'L0098765450',
      loanAmount: 520000,
      interestRate: 5.75,
      estimatedClosingDate: new Date(Date.now() + 28 * 24 * 60 * 60 * 1000),
      tasksCount: 4,
      status: 'PendingApproval',
      statusLabel: 'Conditional Approval',
      loanProgram: '30 Year Fixed',
      loanType: 'Refinance',
      monthlySavings: 300,
      newMonthlyPayment: 3100,
      redirectURL: 'https://mla.loandepot.com/loan/refi-pending-001/tasks',
    },
  ],
  'documents-pending': [
    {
      id: 'mla-002',
      propertyAddress: '123 Main Street, Irvine, CA 92618',
      loanNumber: 'L0012345679',
      loanAmount: 425000,
      interestRate: 6.875,
      estimatedClosingDate: new Date(Date.now() + 45 * 24 * 60 * 60 * 1000),
      tasksCount: 8,
      status: 'PendingApproval',
      statusLabel: 'Documents Needed',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://mla.loandepot.com/loan/mla-002/tasks',
    },
  ],
  'conditional-approval': [
    {
      id: 'mla-003',
      propertyAddress: '789 Maple Drive, Newport Beach, CA 92660',
      loanNumber: 'L0012345680',
      loanAmount: 680000,
      interestRate: 6.625,
      estimatedClosingDate: new Date(Date.now() + 20 * 24 * 60 * 60 * 1000),
      tasksCount: 3,
      status: 'PendingApproval',
      statusLabel: 'Conditional Approval',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://mla.loandepot.com/loan/mla-003/tasks',
    },
  ],
  'final-approval': [
    {
      id: 'mla-004',
      propertyAddress: '321 Palm Lane, Laguna Beach, CA 92651',
      loanNumber: 'L0012345681',
      loanAmount: 850000,
      interestRate: 6.5,
      estimatedClosingDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
      tasksCount: 0,
      status: 'PendingApproval',
      statusLabel: 'Final Approval',
      loanProgram: '15 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://mla.loandepot.com/loan/mla-004/tasks',
    },
  ],
  'paying-loan': [
    {
      id: 'loan-paying-001',
      propertyAddress: '555 Ocean View Dr, Dana Point, CA 92629',
      loanNumber: 'L0012345700',
      loanAmount: 450000,
      interestRate: 5.25,
      estimatedClosingDate: undefined,
      tasksCount: 0,
      status: 'Paying',
      statusLabel: 'Active Loan',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://servicing.loandepot.com/loan/L0012345700',
    },
  ],
  'historic-loan': [
    {
      id: 'loan-historic-001',
      propertyAddress: '888 Legacy Lane, Mission Viejo, CA 92691',
      loanNumber: 'L0012340001',
      loanAmount: 325000,
      interestRate: 4.5,
      estimatedClosingDate: undefined,
      tasksCount: 0,
      status: 'Historic',
      statusLabel: 'Paid Off',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://servicing.loandepot.com/loan/L0012340001/history',
    },
  ],
  funded: [
    {
      id: 'loan-funded-001',
      propertyAddress: '200 Sunrise Blvd, Laguna Niguel, CA 92677',
      loanNumber: 'L0012345800',
      loanAmount: 500000,
      interestRate: 6.25,
      estimatedClosingDate: undefined,
      tasksCount: 0,
      status: 'Paying',
      statusLabel: 'Funded',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://mla.loandepot.com/loan/loan-funded-001',
    },
  ],
  'active-and-funded': [
    {
      id: 'refi-001',
      propertyAddress: '123 Main Street, Irvine, CA 92618',
      loanNumber: 'L0098765432',
      loanAmount: 425000,
      interestRate: 5.875,
      estimatedClosingDate: new Date(Date.now() + 21 * 24 * 60 * 60 * 1000),
      tasksCount: 3,
      status: 'PendingApproval',
      statusLabel: 'Application Pending',
      loanProgram: '30 Year Fixed',
      loanType: 'Refinance',
      monthlySavings: 250,
      newMonthlyPayment: 2150,
      redirectURL: 'https://mla.loandepot.com/loan/refi-001/tasks',
    },
    {
      id: 'purchase-001',
      propertyAddress: '1234 Luxury Lane, Irvine, CA 92620',
      loanNumber: 'L0098765499',
      loanAmount: 750000,
      interestRate: 6.5,
      estimatedClosingDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
      tasksCount: 2,
      status: 'PendingApproval',
      statusLabel: 'In Progress',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://mla.loandepot.com/loan/purchase-001/tasks',
    },
    {
      id: 'loan-funded-001',
      propertyAddress: '200 Sunrise Blvd, Laguna Niguel, CA 92677',
      loanNumber: 'L0012345800',
      loanAmount: 500000,
      interestRate: 6.25,
      estimatedClosingDate: undefined,
      tasksCount: 0,
      status: 'Paying',
      statusLabel: 'Funded',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://mla.loandepot.com/loan/loan-funded-001',
    },
    {
      id: 'loan-historic-002',
      propertyAddress: '888 Legacy Lane, Mission Viejo, CA 92691',
      loanNumber: 'L0012340001',
      loanAmount: 325000,
      interestRate: 4.5,
      estimatedClosingDate: undefined,
      tasksCount: 0,
      status: 'Historic',
      statusLabel: 'Paid Off',
      loanProgram: '30 Year Fixed',
      loanType: 'Purchase',
      redirectURL: 'https://servicing.loandepot.com/loan/L0012340001/history',
    },
  ],
  'no-application': [],
};
